import { fromJS } from 'immutable';
import normaliseResponse from 'utils/normaliseResponse';

import * as constants from 'actions/orders/constants';
import initialState from './initialState';

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_SKUS_SUCCESS: {
      const { skus, projectId } = action;

      const prevAllIds = state.get('allIds');

      const normalisedResponse = normaliseResponse(skus, undefined, 'sku_id');
      const { byId } = normalisedResponse;
      const allIdsByProject = normalisedResponse.allIds;
      const allIds = prevAllIds.concat(
        allIdsByProject.filter((id) => prevAllIds.indexOf(id) < 0)
      );

      return state
        .mergeIn(['byId'], fromJS(byId))
        .set('allIds', fromJS(allIds))
        .setIn(['byProjectId', `${projectId}`], fromJS(allIdsByProject));
    }

    default:
      return state;
  }
};
